import {request} from "../../../util/Request";
import Error from "../../../util/Error";

const DEFAULT_REEXPORT_STATE = {
    order_code: null,
    second_delivery_place_importer: null,
    call_off_date_importer: null,
}

export default {
    data() {
        return {
            secondUpdateModal: {
                visibility: false,
                formFields: {...DEFAULT_REEXPORT_STATE},
                formSubmitUrl: 'order/drafts/client/ctc/update',
            }
        }
    },
    methods: {
        handleCtcUpdateClick(record, url = 'order/drafts/client/ctc/update') {
            this.secondUpdateModal.visibility = true;
            this.secondUpdateModal.formFields.order_code = record.order_code;
            this.secondUpdateModal.formFields.second_delivery_place_importer = null;
            this.secondUpdateModal.formFields.call_off_date_importer = null;
            this.secondUpdateModal.formSubmitUrl = url
        },
        async handleCtcUpdateSubmit() {
            try {
                const response = await request({
                    url: this.secondUpdateModal.formSubmitUrl,
                    method: "POST",
                    data: {...this.secondUpdateModal.formFields}
                })

                this.resetCtcUpdateOperation()
                const {success} = response
                if(success) {
                    this.itemUpdated()
                } else {
                    this.itemEditFails()
                }
                this.refreshList();
            } catch (error) {
                if (error.request && error.request.status && error.request.status === 422) {
                    this.formErrors = new Error(JSON.parse(error.request.responseText).errors)
                    return false
                }

                this.handleServerError(error)
            }
        },
        resetCtcUpdateOperation() {
            this.secondUpdateModal.visibility = false;
            this.secondUpdateModal.formFields = {...DEFAULT_REEXPORT_STATE};
        },
    }
}
